import { env } from '../config/env';

/**
 * Global fetch interceptor for the admin portal.
 * Intercepts all fetch calls and redirects to login on 401/403 responses.
 * This ensures that regardless of how a component makes API calls
 * (adminApi, direct fetch, apiRequest, etc.), unauthorized responses
 * are always handled consistently.
 */

let isRedirecting = false; // Prevent multiple simultaneous redirects

const originalFetch = window.fetch.bind(window);

const interceptedFetch: typeof window.fetch = async (input, init) => {
  const response = await originalFetch(input, init);

  // Only intercept responses from our API
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : (input as Request).url;
  const isApiCall = url.startsWith(env.apiBaseUrl);

  if (isApiCall && (response.status === 401 || response.status === 403)) {
    // Don't intercept auth endpoints (login, signup, etc.) to avoid redirect loops
    const isAuthEndpoint = url.includes('/auth/signin') || 
                           url.includes('/auth/signup') || 
                           url.includes('/auth/confirmotp') ||
                           url.includes('/auth/forgot-password') ||
                           url.includes('/auth/reset-password');

    if (!isAuthEndpoint && !isRedirecting) {
      isRedirecting = true;
      console.warn(`[FetchInterceptor] ${response.status} response from ${url} — redirecting to login`);

      // Clear auth data
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      localStorage.removeItem('phone');
      localStorage.removeItem('role');
      localStorage.removeItem('permissions');

      // Redirect to login
      window.location.href = '/auth/login';
    }
  }

  return response;
};

/**
 * Install the global fetch interceptor.
 * Call this once at app startup (in main.tsx).
 */
export function installFetchInterceptor() {
  window.fetch = interceptedFetch;
}
